import BuyFundAssets from "./BuyFundAssets";

const buyFundAssets = {
  BuyFundAssets
};

export default buyFundAssets;